import type { SVGProps } from 'react';
import React from 'react';
import { twMerge } from 'tailwind-merge';

export const CloseIcon: React.FC<SVGProps<SVGSVGElement>> = ({ className, color = '#A3ACBD', ...props }) => (
  <svg
    className={twMerge('cursor-pointer', className)}
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.40963 5.47078L11.3593 0.520996L12.7735 1.93521L7.82383 6.88498L12.7735 11.8347L11.3593 13.2489L6.40963 8.29918L1.45986 13.2489L0.0456543 11.8347L4.99543 6.88498L0.0456543 1.93521L1.45986 0.520996L6.40963 5.47078Z"
      fill={color}
    />
  </svg>
);
